import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Table } from 'src/components';
import { onlyNumber, roundFloat } from 'src/core/utils/formater';
import { PlusCircleOutlined } from '@ant-design/icons';
import {
  Modal,
  Form,
  Row,
  Col,
  Button,
  Typography,
  Input,
  Divider,
  Select,
} from 'antd';
import newAlert from 'src/components/newAlert';
import { set_alert } from 'src/core/actions/alert';
import CustomDatePicker from 'src/components/common/datePicker';
import { customColumns, customSummary } from './dataStructure/data';

import { start_loading, end_loading } from '../../../core/actions/loader';

const { Option } = Select;
const { Text } = Typography;

const types = {
  '01': '01-Санхүүгийн дэмжлэг',
  '02': '02-Хандив',
};

const MainPage = () => {
  const dispatch = useDispatch();

  const socket = useSelector((state) => state.socket);
  const data_date = useSelector((state) => state.data_date);

  const [tableData, setTableData] = useState([]);
  const [tableDataSum, setTableDataSum] = useState({});
  const [addVisible, setAddVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const [addForm] = Form.useForm();
  const [deleteForm] = Form.useForm();

  const generateTailan = (month) => {
    socket.on('request_out', ({ status, content }) => {
      console.log('🚀 ~ socket.on ~ data_temp:', content);
      socket.removeAllListeners('request_out');

      if (status === '0') {
        setTableData(content?.table_data || []);
        setTableDataSum(content?.total_dun || {});
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }

      dispatch(end_loading({}));
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: { action_type: 'get_tm1g', month: String(month) },
    });

    dispatch(start_loading({}));
  };

  const deleteValue = (deleteData) => {
    socket.on('request_out', (data) => {
      const data_temp = data;
      socket.removeAllListeners('request_out');

      if (data_temp.status === '0') {
        newAlert({ type: 'success', msg: 'Амжилттай устгагдлаа' });
        generateTailan(data_date.month);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
        dispatch(end_loading({}));
      }
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: {
        action_type: 'delete_tm1g',
        id: deleteData.delete_id,
      },
    });

    dispatch(start_loading({}));
  };

  const addValue = (saveData) => {
    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      newAlert({
        type: status === '0' ? 'success' : 'error',
        msg: content.Message,
        functions: {
          onSuccess: [generateTailan(data_date.month)],
        },
      });

      dispatch(end_loading({}));
    });
    socket.emit('request_in', {
      channel: 'ts007_00_hungulult_manage',
      content: {
        action_type: 'add_tm1g',
        action_data: saveData,
        month: String(data_date.month),
      },
    });

    dispatch(start_loading({}));
  };

  useEffect(() => {
    if (data_date) {
      generateTailan(data_date.month);
    }
  }, [data_date]);

  const addAction = () => {
    setAddVisible(true);
  };

  const deleteAction = (row) => {
    deleteForm.setFieldsValue({
      delete_id: row?.id,
    });

    setDeleteVisible(true);
  };

  const title = () => (
    <>
      <div className="table-title-text-center">
        Санхүүгийн дэмжлэг, хандивын гэрээний бүртгэл /ТМ-1г/
      </div>
      <Button
        className="add-btn"
        type="primary"
        size="small"
        icon={<PlusCircleOutlined />}
        onClick={() => {
          addAction();
        }}
      >
        Нэмэх
      </Button>
    </>
  );

  return (
    <>
      <div className="table-antd-div no-scroll">
        <Table
          columns={customColumns({
            customDelete: deleteAction,
          })}
          dataSource={tableData}
          scroll={{
            // y: 'max-content',
            x: 'max-content',
          }}
          summaryList={{
            sumColumn: customSummary,
            sumDataSource: tableDataSum,
          }}
          title={title}
        />
      </div>
      <Modal
        className="custom-modal"
        title="Бүртгэл устгах"
        visible={deleteVisible}
        closable={false}
        maskClosable={false}
        width={500}
        footer={null}
      >
        <DeleteModal
          onClose={() => {
            setDeleteVisible(false);
          }}
          form={deleteForm}
          deleteValue={deleteValue}
        />
      </Modal>
      <Modal
        className="custom-modal"
        title="Бүртгэлийн дугаар үүсгэх"
        visible={addVisible}
        closable={false}
        maskClosable={false}
        width={750}
        footer={null}
      >
        <AddModal
          onClose={() => {
            setAddVisible(false);
          }}
          form={addForm}
          saveValues={addValue}
        />
      </Modal>
    </>
  );
};

const layout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 18 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
};

const AddModal = ({
  onClose = () => {},
  form = null,
  saveValues = () => {},
}) => {
  const onFinish = (values) => {
    saveValues(values);
    form.resetFields();
    onClose();
  };

  const onCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      className="register-form"
      labelCol={{ xs: { span: 12 }, sm: { span: 18 } }}
      wrapperCol={{ xs: { span: 12 }, sm: { span: 6 } }}
      size="small"
    >
      <Form.Item
        name="turul"
        label="Төрөл"
        labelAlign="left"
        rules={[{ required: true, message: 'Төрөл оруулна уу' }]}
      >
        <Select className="w-100">
          {Object.entries(types).map(([key, value]) => (
            <Option key={key} value={key}>
              {value}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="ner_olgoson"
        label="Олгосон этгээдийн нэр"
        labelAlign="left"
        rules={[{ required: true, message: 'Нэр оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="ttd_olgoson"
        label="Олгосон этгээдийн ТТД"
        labelAlign="left"
        rules={[{ required: true, message: 'ТТД оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="ner_avsan"
        label="Хүлээн авсан этгээдийн нэр"
        labelAlign="left"
        rules={[{ required: true, message: 'Нэр оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="ttd_avsan"
        label="Хүлээн авсан этгээдийн ТТД"
        labelAlign="left"
        rules={[{ required: true, message: 'ТТД оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="ognoo"
        label="Гэрээний огноо"
        labelAlign="left"
        rules={[{ required: true, message: 'Огноо оруулна уу' }]}
      >
        <CustomDatePicker customClass="w-100 h-25" />
      </Form.Item>

      <Form.Item
        name="dugaar"
        label="Гэрээний дугаар"
        labelAlign="left"
        rules={[{ required: true, message: 'Дугаар оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="geree_turul"
        label="Гэрээний төрөл"
        labelAlign="left"
        rules={[{ required: true, message: 'Гэрээний төрөл оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="geree_zoriulalt"
        label="Гэрээний зориулалт"
        labelAlign="left"
        rules={[{ required: true, message: 'Зориулалт оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="geree_hugatsaa"
        label="Хэрэгжих хугацаа"
        labelAlign="left"
        rules={[{ required: true, message: 'Хугацаа оруулна уу' }]}
      >
        <Input className="w-100" />
      </Form.Item>

      <Form.Item
        name="geree_dun"
        label="Гэрээний дүн"
        labelAlign="left"
        rules={[{ required: true, message: 'Дүн оруулна уу' }]}
        normalize={onlyNumber}
      >
        <Input className="w-100 text-align-r" />
      </Form.Item>

      <Form.Item
        name="notariat"
        label="Нотариатаар баталгаажуулсан эсэх"
        labelAlign="left"
        rules={[{ required: true, message: 'Сонголт хийнэ үү' }]}
      >
        <Select className="w-100" placeholder="Сонгох">
          <Select.Option value>Тийм</Select.Option>
          <Select.Option value={false}>Үгүй</Select.Option>
        </Select>
      </Form.Item>

      <Row>
        <Col span={24} className="text-align-r">
          <Form.Item noStyle>
            <Button
              onClick={onCancel}
              className="cancel-btn"
              type="primary"
              shape="round"
            >
              Цуцлах
            </Button>
            <Button
              className="confirm-btn ml-5"
              type="primary"
              shape="round"
              htmlType="submit"
            >
              Хадгалах
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

const DeleteModal = ({
  onClose = () => {},
  form = null,
  deleteValue = () => {},
}) => {
  const onFinish = (values) => {
    deleteValue(values);
    form.resetFields();
    onClose();
  };

  const onCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <div className="dans-medeelel-container">
      <Form
        form={form}
        onFinish={onFinish}
        className="register-form"
        {...layout}
        size="small"
      >
        <Form.Item name="delete_id" hidden />
        <Text>Та энэ үйлдлийг хийхдээ итгэлтэй байна уу?</Text>
        <Row>
          <Col span={24} className="text-align-r">
            <Form.Item noStyle>
              <Button
                onClick={onCancel}
                className="cancel-btn"
                type="primary"
                shape="round"
              >
                Цуцлах
              </Button>
              <Button
                className="confirm-btn ml-5"
                type="primary"
                shape="round"
                htmlType="submit"
              >
                Устгах
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default MainPage;
